import { render, staticRenderFns } from "./heroes.vue?vue&type=template&id=2a7d4d3a&scoped=true"
import script from "./heroes.vue?vue&type=script&lang=js"
export * from "./heroes.vue?vue&type=script&lang=js"
import style0 from "./heroes.vue?vue&type=style&index=0&id=2a7d4d3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7d4d3a",
  null
  
)

export default component.exports